<section class="plans__container">
  <div class="plans">
    <!-- Titles -->
    <div class="plansHero">
      <ddc-text-gradient
        class="dashboard-header-txt dashboard-title text-3xl"
        [_text]="'Simple, Fast, Worthy'"
        [_type]="'1'"
      ></ddc-text-gradient>
      <ddc-text-gradient
        class="dashboard-header-txt dashboard-title text-3xl"
        [_text]="'No surprise fees.'"
        [_type]="'1'"
      ></ddc-text-gradient>
      @if (_currentUserInfo()) {
        <div class="ddc-current-plan">
          <ddc-text-gradient
            class="dashboard-header-txt dashboard-title text-3xl"
            [_text]="'Current Plan'"
            [_type]="'2'"
          ></ddc-text-gradient>
          <span
            class="bg-purple-100 text-red-800 text-xl font-medium me-2 px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300 mx-auto"
          >
            {{ _currentUserInfo().subscription }}
          </span>
        </div>
      }
    </div>
    <!-- Plans -->
    <div class="planItem__container">
      <ddc-pricing-plan plan="free" [infoOnly]="true"></ddc-pricing-plan>
      <ddc-pricing-plan plan="plus" [toBillingPage]="toBillingPage"></ddc-pricing-plan>
      <ddc-pricing-plan plan="pro" [toBillingPage]="toBillingPage"></ddc-pricing-plan>
    </div>
  </div>
</section>
